// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"01993fee","152":"6420b0f4","184":"04f831d2","383":"816a8a5a","403":"327e79d1","422":"6b58cd29","427":"f4fa12fb","488":"ec6eec6c","704":"f061550b","720":"d3c6affd","757":"5c385117","823":"e6818721","916":"fc141749","977":"d8568619"}[chunkId] + ".chunk.js";
};